import React from "react";
import { Icons } from "2g-icons";

import createBaseRenderer from "./createBaseRenderer";

export default createBaseRenderer({
  name: "kolize",
  placeholderText: "0",
  className: val => (val > 0 ? "is-kolize" : undefined),
  content: ({ val }) => (
    <>
      <span>{val}</span>
      <>{val > 0 ? <Icons.Warning /> : undefined}</>
    </>
  )
});
